import React from 'react';
import { faBullseye, faCertificate, faCirclePlay, faComments, faEnvelopeOpenText, faFileLines } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CommonImg from '../../../img/Course-Elements/Common.png';

const CourseOperate = () => {
    return (
        <div className='px-4 md:px-12 my-6'>
            <h1 className='text-3xl text-blue-500 font-semibold mb-8 text-center'>How does your course operate?</h1>
            <div className='grid grid-cols-1 md:grid-cols-3 md:gap-20 gap-4'>
                <div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faCirclePlay} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>Learn Concepts</h1>
                            <p className='text-sm'>Go through training videos to learn concepts</p>
                        </div>
                    </div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer my-4'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faBullseye} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>Hands-on practice</h1>
                            <p className='text-sm'>Work on assignments and projects. Use our in-browser IDE for coding practice.</p>
                        </div>
                    </div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faFileLines} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>Take final exam</h1>
                            <p className='text-sm'>Complete your training by taking the final exam</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faEnvelopeOpenText} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>Test yourself</h1>
                            <p className='text-sm'>Test your knowledge through quizzes & module tests at regular intervals</p>
                        </div>
                    </div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer my-2'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faComments} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>1:1 Doubt Solving</h1>
                            <p className='text-sm'>Get your doubts solved by experts through Q&A forum within 24 hours</p>
                        </div>
                    </div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faCertificate} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>Get Certificate</h1>
                            <p className='text-sm'>Get certificate in Web development upon successful completion of training</p>
                        </div>
                    </div>
                </div>
                <div>
                    <img src={CommonImg} alt="" />
                </div>
            </div>

        </div>
    );
};

export default CourseOperate;